import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import InpageDraggableSection from './InpageDraggableSection';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EMBED_LIMIT, getHasReachedEmbedLimit } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { isEmbed, isFixedLayoutSection } from 'ContentEditorUI/types/Section';
import { makeGetInvalidModuleSchemasForStaticSection } from 'ContentEditorUI/redux/selectors/moduleSchemaSelectors';
import I18n from 'I18n';
import UIList from 'UIComponents/list/UIList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useSectionNotAddableMessage = section => {
  const hasReachedEmbedLimit = useSelector(getHasReachedEmbedLimit);
  const getInvalidModuleSchemasForStaticSection = useMemo(() => makeGetInvalidModuleSchemasForStaticSection(section), [section]);
  const invalidModuleSchemasForStaticSection = useSelector(getInvalidModuleSchemasForStaticSection);
  let notAddableMessage;
  let isSectionDraggable = true;
  if (isEmbed(section)) {
    isSectionDraggable = !hasReachedEmbedLimit;
    notAddableMessage = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "inpage.layout.addSection.embedReachedLimit",
      options: {
        limit: I18n.formatNumber(EMBED_LIMIT)
      }
    });
  } else if (isFixedLayoutSection(section)) {
    isSectionDraggable = invalidModuleSchemasForStaticSection.length === 0;
    notAddableMessage = /*#__PURE__*/_jsxs("p", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "inpage.layout.addSection.fixedLayoutMissingModuleSchemas.unavailabilityErrorReason",
        options: {
          count: I18n.formatNumber(invalidModuleSchemasForStaticSection.length)
        }
      }), /*#__PURE__*/_jsx(UIList, {
        styled: true,
        className: "m-top-1",
        children: invalidModuleSchemasForStaticSection.map(({
          name
        }) => /*#__PURE__*/_jsx("strong", {
          children: name
        }, name))
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "inpage.layout.addSection.fixedLayoutMissingModuleSchemas.unavailabilityErrorResolution"
      })]
    });
  }
  return {
    isSectionDraggable,
    notAddableMessage
  };
};
const InpageDraggableThemeSectionContainer = ({
  onDragEnd,
  onDragStart,
  section,
  themePath
}) => {
  const {
    isSectionDraggable,
    notAddableMessage
  } = useSectionNotAddableMessage(section);
  return /*#__PURE__*/_jsx(InpageDraggableSection, {
    section: section,
    onDragStart: onDragStart,
    onDragEnd: onDragEnd,
    themePath: themePath,
    isDraggable: isSectionDraggable,
    notAddableMessage: notAddableMessage
  });
};
export default InpageDraggableThemeSectionContainer;